
import { motion } from "framer-motion";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRight01Icon } from "@hugeicons/core-free-icons";
import heroImage from "../../assets/hero-main.webp";
import { ShinyButton } from "../ui/shiny-button";
import { AnimatedText } from "../ui/animated-text";
import { AnimatedImage } from "../ui/animated-image";
import { BeamsBackground } from "../ui/beams-background";

export function Hero() {
    return (
        <section className="relative min-h-screen flex flex-col items-center justify-center pt-24 pb-8 px-4 sm:px-6 overflow-hidden">
        
            
            {/* Background Gradient Spotlights */}
            <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-purple-900/40 rounded-full blur-[120px] pointer-events-none z-0" />
            <div className="absolute bottom-[-10%] right-[-5%] w-[400px] h-[400px] bg-blue-900/30 rounded-full blur-[100px] pointer-events-none z-0" />

            <div className="container mx-auto max-w-6xl relative z-10 flex flex-col items-center text-left sm:text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="mb-8"
                >
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-medium text-gray-300 mb-6 backdrop-blur-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                        Sofort lieferbar
                        <HugeiconsIcon icon={ArrowRight01Icon} size={12} className="ml-1" />
                    </div>

                    <AnimatedText
                        lines={["TSE-Komplettlösung", "ohne Warteliste"]}
                        className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-tight mb-4 sm:mb-6"
                    />

                    <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-4xl mx-auto mb-6 sm:mb-10 text-balance px-2">
                        Die TBOX ist Ihre sofort verfügbare Lösung für TSE-Compliance. 
                        <br />
                        TSE BOX, Taxameter, TSE-Karte und Installation – alles inklusive.
                    </p>

                    <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-start sm:justify-center gap-3 sm:gap-4 w-full sm:w-auto px-4 sm:px-0">
                        <ShinyButton glow={true} className="w-full sm:w-auto min-h-[44px]" onClick={() => {
                            const contactSection = document.getElementById('contact');
                            if (contactSection) {
                                contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                        }}>
                            Termin Vereinbaren
                        </ShinyButton>
                        <a href="#features" className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 text-white border border-white/20 rounded-full font-bold text-base sm:text-lg hover:bg-white/10 transition-all backdrop-blur-sm min-h-[44px] flex items-center justify-center">
                            Mehr erfahren
                        </a>
                    </div>
                </motion.div>

                {/* Hero Image Placeholder with "Float" animation */}
                <div className="w-full max-w-4xl relative mt-8">
                    <motion.div
                        animate={{ y: [0, -10, 0] }}
                        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
                        className="relative rounded-3xl shadow-2xl shadow-purple-900/20 border border-white/10 group overflow-hidden"
                        style={{ aspectRatio: '4288 / 3968' }}
                    >
                        <AnimatedImage
                            src={heroImage}
                            alt="TBOX Gerät — TSE-zertifizierte Taxameter-Komplettlösung für Taxiunternehmen"
                            className="w-full h-full group-hover:scale-105 transition-transform duration-700"
                            delay={0.2}
                            loading="eager"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                        {/* Floating UI Elements mocking AR interface */}
                        {/* <motion.div
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 1, duration: 0.8 }}
                            className="absolute top-10 left-10 p-3 bg-black/60 backdrop-blur-md rounded-xl border border-white/10 flex items-center gap-3 shadow-xl"
                        >
                            <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">
                                <div className="w-2 h-2 bg-green-400 rounded-full" />
                            </div>
                            <div>
                                <h4 className="text-xs text-gray-400 uppercase tracking-widest">Status</h4>
                                <p className="text-sm font-bold">Bereit</p>
                            </div>
                        </motion.div> */}

                        <motion.div
                            initial={{ x: 20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 1.2, duration: 0.8 }}
                            className="absolute bottom-4 right-4 sm:bottom-10 sm:right-10 p-2 sm:p-3 bg-white/90 text-black backdrop-blur-md rounded-full border border-white/10 flex items-center gap-2 sm:gap-4 shadow-xl px-3 sm:px-6"
                        >
                            <span className="text-[10px] sm:text-xs font-bold tracking-wider">SOFORT LIEFERBAR</span>
                        </motion.div>
                    </motion.div>
                    <p className="text-xs sm:text-sm text-gray-500 text-center mt-4 sm:mt-6 italic">
                        Das fertige Produkt kann leicht von der Darstellung abweichen
                    </p>
                </div>
            </div>
        </section>
    );
}
